import React from "react";
import { Link } from "react-router-dom"
import { connect } from "react-redux";
import { setSingleProduct } from "../../Redux/slices/singleProduct";
import Price from "../../Parts/Price";
import Discount from "../ProductPage/Discount";

const mapStateToProps = state => {
    return {
        pluginPath: state.appSettings.pluginPath,
        mediaType: state.appSettings.mediaType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSingleProduct: payload => dispatch(setSingleProduct(payload))
    };
}

class Item extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.hoverState = this.hoverState.bind(this);
        this.state = {
            displaySeconaryImage: false,
            secondaryImageSrc: ""
        }
    }

    onClick() {
        this.props.setSingleProduct({
            title: this.props.title,
            mainImageSrc: this.props.mediaUrl,
            variations: this.props.variations,
            categories: [{
                name: this.props.category || "Veronica Virta",
                uri: "/"
            }]
        });
    }

    hoverState(action) {
        if (this.props.mediaType === "desktop" && action === "enter" && this.state.secondaryImageSrc === "") {
            var filteredImages = this.props.mediaGallery.filter(item => {
                return (item.mediaItemUrl !== this.props.mediaUrl);
            });

            if (filteredImages.length < 1) {
                return null;
            }

            this.setState({
                displaySeconaryImage: true,
                secondaryImageSrc: filteredImages[0].mediaItemUrl
            });
        } else if (this.props.mediaType === "desktop" && action === "enter") {
            this.setState({
                displaySeconaryImage: true
            });
        } else if (this.props.mediaType === "desktop" && action === "exit") {
            this.setState({
                displaySeconaryImage: false
            });
        }
    }

    render() {
        if (this.props.placeholder === true) {
            return <div className="grid-item placeholder-loading">
                <div className="image-wrap">
                    <img className="placeholder-img" src={this.props.pluginPath + "/assets/LoadingPlaceholder.png"} />
                </div>

                <div className="text-wrap">
                    <span className="loading-text"></span>
                    <span className="loading-text"></span>
                    <span className="loading-text"></span>
                </div>
            </div>
        }

        // Set sale price is on sale
        var price = 0;
        var salePrice = null;
        var onSale = false;
		var discountPercent = null;

        if (this.props.variations[0]) {
            price = this.props.variations[0].regularPrice;

            // If product is on sale
            if (this.props.variations[0].onSale === true) {
                onSale = true;
                salePrice = <Price className="price sale-price">{this.props.variations[0].price}</Price>;
				discountPercent = <span className="discount-percent">{(100 - Math.round((parseInt(this.props.variations[0].price) / parseInt(price)) * 100))}%</span>;
            }
        }

        // Display secondary image on hover
        var secondaryImage = null;
        if (this.state.displaySeconaryImage === true && this.state.secondaryImageSrc !== "") {
            secondaryImage = <img className="secondary-image" src={this.state.secondaryImageSrc} />
        } else if (this.state.secondaryImageSrc !== "") {
            secondaryImage = <img className="secondary-image hidden" src={this.state.secondaryImageSrc} />
        }

        return <Link to={this.props.slug} onClick={this.onClick} className="grid-item" onMouseEnter={() => this.hoverState("enter")} onMouseLeave={() => this.hoverState("exit")}>
            <div className="image-wrap">
                <Discount variations={this.props.variations} />
                <img src={this.props.mediaUrl} />
                {secondaryImage}
            </div>

            <div className="text-wrap">
                <span className="item-category">{this.props.category || "Veronica Virta"}</span>
                <span className="item-title">{this.props.title}</span>
                <span className="item-price">
                    {salePrice}
                    <Price className={"price" + (onSale ? " regular-price-on-sale" : "")}>{price}</Price>
					{discountPercent}
                </span>
            </div>
        </Link>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);